import PropTypes from 'prop-types';
import React from 'react';

import {InternalLink as InternalLinkType} from 'notebook/mediocre/MediocreConstants';
import InternalLink from 'notebook/mediocre/mentions/InternalLink';
import {ElementKeyboardEvent, InputChangeEvent} from 'util/Types';

interface InternalLinkInputProps {
  link: InternalLinkType | null | undefined;
  placeholder?: string;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  updateText: (text: string) => void;
  text: string;
}

class InternalLinkInput extends React.Component<InternalLinkInputProps> {
  static propTypes = {
    link: PropTypes.shape({
      iconId: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
    }),
    placeholder: PropTypes.string,
    onKeyDown: PropTypes.func,
    updateText: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
  };

  inputRef = React.createRef<HTMLInputElement>();

  focus(): void {
    this.inputRef.current!.focus();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleKeyDown = (e: ElementKeyboardEvent) => {
    // BACKSPACE and cursor next to chip (caret position == 0)
    if (e.keyCode === 8 && this.inputRef.current!.selectionStart === 0) {
      this.props.updateText('');
    }

    if (this.props.onKeyDown) {
      this.props.onKeyDown(e);
    }
  };

  // User types into the box = delete the chip, but maintain the text
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleChange = (e: InputChangeEvent) => {
    const text = this.props.link ? `${this.props.link.name}${e.target.value}` : e.target.value;
    this.props.updateText(text);
  };

  render(): JSX.Element {
    return (
      <div className="internalLinkInput">
        {this.props.link && <InternalLink internalLink={this.props.link} />}
        <input
          className="internalLinkInput-input"
          value={this.props.text}
          ref={this.inputRef}
          onKeyDown={this.handleKeyDown}
          onChange={this.handleChange}
          placeholder={this.props.placeholder}
        />
      </div>
    );
  }
}

export default InternalLinkInput;
